/** Template id used in the stickers grid before insert (patched RVE bundle). */
export const ASPECTLY_QR_STICKER_TEMPLATE_ID = 'aspectly-qr-code';

/** Dedicated stickers sidebar tab for Aspectly widgets (SDK category string). */
export const ASPECTLY_QR_STICKER_CATEGORY = 'Aspectly';

export const ASPECTLY_QR_DEFAULT_URL = 'https://google.com/search?q=aspectly.ai';

export interface AspectlyQrStickerPayload {
  kind: 'qr';
  url: string;
  svg: string;
}

/** Parse persisted ``StickerItem.content`` JSON for Aspectly QR widgets. */
export function parseAspectlyQrStickerContent(
  content: string,
): AspectlyQrStickerPayload | null {
  if (!content || content === ASPECTLY_QR_STICKER_TEMPLATE_ID) {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(content);
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      (parsed as AspectlyQrStickerPayload).kind === 'qr'
    ) {
      const payload = parsed as AspectlyQrStickerPayload;
      if (typeof payload.url === 'string' && typeof payload.svg === 'string') {
        return payload;
      }
    }
  } catch {
    return null;
  }
  return null;
}

export function isAspectlyQrStickerContent(content: string): boolean {
  return parseAspectlyQrStickerContent(content) !== null;
}

/** Generate QR SVG markup for embedding in ``StickerItem.content``. */
export async function generateQrSvg(url: string): Promise<string> {
  const QRCode = await import('qrcode');
  return QRCode.toString(url, {
    type: 'svg',
    margin: 1,
    errorCorrectionLevel: 'M',
  });
}

/** Build serialized ``StickerItem.content`` for a QR destination URL. */
export async function buildAspectlyQrStickerContent(url: string): Promise<string> {
  const normalized = url.trim() || ASPECTLY_QR_DEFAULT_URL;
  const payload: AspectlyQrStickerPayload = {
    kind: 'qr',
    url: normalized,
    svg: '',
  };
  return JSON.stringify(payload);
}
